import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, useMediaQuery, useTheme, } from "@mui/material";
import "moment/locale/en-gb";
import "moment/locale/nl";
import { Trans, useTranslation } from "react-i18next";
import EventAuthFooter from "@ui/components/Footers/EventAuthFooter";
import { centered } from "@ui/style/style";
import { SwitchLanguage } from "@ui/components/language";
export const RelationsDayHomepage = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isBelow1024 = useMediaQuery(theme.breakpoints.down(1025)); // to trigger responsiveness on 1024px
    const isBelow390 = useMediaQuery(theme.breakpoints.down(391)); // to trigger responsiveness on 391px
    return (_jsxs(Box, { display: "flex", flexDirection: "column", sx: {
            height: "100dvh",
            position: "relative",
            overflow: "hidden",
        }, children: [_jsx(Box, { sx: {
                    position: "absolute",
                    top: "120px",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    zIndex: 1, // Put it behind the main content
                }, className: "curve-image", children: _jsx("img", { src: "/assets/images/main-page.png", alt: "Background image", style: { width: "100%", height: "100%" } }) }), _jsx(Box, { sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 0, // Put it behind everything else
                    backgroundImage: `url('/assets/images/event-bg.png')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                } }), _jsxs(Box, { sx: {
                    width: "100%",
                    overflow: "auto",
                    transition: "padding-left .2s ease-in-out",
                    zIndex: 100,
                    height: "100%",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                }, className: "events__main-content-wrapper", children: [_jsx(Box, { sx: {
                            position: "absolute",
                            top: isBelow390 ? "8px" : isBelow1024 ? "16px" : "24px",
                            right: isBelow390 ? "8px" : isBelow1024 ? "20px" : "48px",
                            zIndex: 16,
                        }, children: _jsx(SwitchLanguage, { buttonProps: {
                                sx: {
                                    borderRadius: 2,
                                    backgroundColor: "white !important",
                                    border: 0,
                                    "&:hover": {
                                        backgroundColor: "lightgray !important",
                                        boxShadow: "none",
                                    },
                                    height: isBelow1024 ? 40 : 48,
                                },
                                style: {
                                    background: "white",
                                },
                                className: "translation-button",
                            } }) }), _jsx(Container, { sx: {
                            [theme.breakpoints.up(1024)]: {
                                mt: 3,
                                pt: 8,
                            },
                            [theme.breakpoints.down(1025)]: {
                                mt: 2,
                                pt: 5,
                            },
                            [theme.breakpoints.down(391)]: {
                                mt: 0,
                                pt: 5,
                            },
                            flex: 1,
                        }, className: "content-container", children: _jsx(Box, { sx: {
                                px: 2,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }, children: _jsxs(Box, { sx: {
                                    ...centered,
                                    flexDirection: "column",
                                }, children: [_jsx(Box, { component: "img", src: "/assets/images/relations-day-logo.svg", sx: {
                                            width: "auto",
                                            height: `min(${isBelow390 ? 188 : isBelow1024 ? 144 : 200}px, 26.5dvh)`,
                                        }, alt: "feature image" }), _jsx(Typography, { fontSize: { xs: 22, sm: 24, lg: 40 }, mt: 2, textAlign: "center", fontFamily: "Formula1", fontWeight: 500, lineHeight: "100%", color: "#FFFFFF", textTransform: "uppercase", children: t("event.relationDay.welcomeTitle") }), _jsxs(Box, { sx: {
                                            display: "flex",
                                            flexDirection: "column",
                                            border: "1px solid #00244D33",
                                            borderRadius: 2,
                                            width: "100%",
                                            maxWidth: 589,
                                            padding: 3,
                                            mt: 3,
                                            gap: 3,
                                            backgroundColor: "#FFFFFF",
                                            boxShadow: "0px 40px 56px 0px #00000014,  0px 16px 40px 0px #0000000F, 0px 4px 8px 0px #0000000A",
                                        }, children: [_jsx(Typography, { variant: "subtitle1", fontWeight: 400, color: "#00244D", children: _jsx(Trans, { i18nKey: t("event.relationDay.welcomeText"), components: {
                                                        bold: _jsx("span", { style: { fontWeight: 500 } }),
                                                        br: _jsx("br", {}),
                                                    } }) }), _jsx(Typography, { variant: "subtitle1", fontWeight: 400, color: "#00244D", children: t("event.seeYou") })] })] }) }) }), _jsx(EventAuthFooter, { logoPosition: "start" })] })] }));
};
